<h2 mat-dialog-title>Recuperar contraseña</h2>
<form (ngSubmit)="submit()">
  <mat-dialog-content>
    <p>Ingrese su correo electrónico para solicitar un enlace de recuperación.</p>
    <p>El enlace tiene una vigencia de 20 minutos. Debe esperar 5 minutos entre solicitudes.</p>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Correo electrónico</mat-label>
      <input matInput type="email" autocomplete="email" [formControl]="email" [readonly]="sending" required>
      <mat-error *ngIf="email.invalid">Ingrese un correo electrónico válido.</mat-error>
    </mat-form-field>
    <p *ngIf="sent" role="status">Si el correo corresponde a una cuenta habilitada, recibirá un enlace para restablecer su contraseña. Revise también la carpeta de correo no deseado.</p>
    <p *ngIf="error" role="alert" class="text-danger">{{ error }}</p>
    <p *ngIf="remainingSeconds > 0">Podrá solicitar otro enlace en {{ countdownDisplay }}.</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button type="button" mat-dialog-close [disabled]="sending">Cerrar</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="email.invalid || sending || remainingSeconds > 0">
      {{ sending ? 'Enviando...' : 'Enviar enlace' }}
    </button>
  </mat-dialog-actions>
</form>
